export default "__VITE_ASSET__BuJjGgq5__"